import ArrayUtils from '../utils/ArrayUtils';

export default class Comparison {
  static areValuesEqual(value1, value2, metadataRule) {

    switch (metadataRule?.type) {
      case 'string-list':
        return Comparison.areStringListValuesEqual(value1, value2, metadataRule);
      default:
        return value1 === value2;
    }
  }

  static areStringListValuesEqual(value1, value2, metadataRule) {
    return ArrayUtils.areArraysEquivalent(value1, value2);
  }
}